var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6625 2.57325C16.4095 2.12665 16.9685 1.42345 17.235 0.594912C16.5331 1.01141 15.765 1.30481 14.9642 1.46241C13.8538 0.287854 12.0946 0.00201207 10.6695 0.76462C9.24441 1.52723 8.50625 3.14949 8.8675 4.72491C5.99218 4.58055 3.31331 3.22234 1.49751 0.988245C0.54988 2.62276 1.03414 4.71223 2.60418 5.76325C2.03644 5.745 1.48128 5.59125 0.985013 5.31491C0.985013 5.32991 0.985013 5.34492 0.985013 5.35992C0.985338 7.0625 2.18532 8.52917 3.85418 8.86659C3.32756 9.00984 2.77518 9.03092 2.23918 8.92825C2.70851 10.3843 4.05047 11.3818 5.58001 11.4116C4.3132 12.4058 2.74874 12.9451 1.13835 12.9424C0.852905 12.9428 0.567688 12.9264 0.28418 12.8933C1.9195 13.9441 3.82282 14.5018 5.76668 14.4999C8.47108 14.5185 11.07 13.4523 12.9822 11.5399C14.8945 9.6275 15.9605 7.02842 15.9417 4.32408C15.9417 4.16908 15.9381 4.01491 15.9308 3.86158C16.6312 3.35541 17.2357 2.72837 17.7158 2.00991C17.0633 2.29913 16.3712 2.48901 15.6625 2.57325Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.f3cca676392d3eb1eaac2880a4f4dc87.svg";
export { ForwardRef as ReactComponent };